import type { IconCard } from './types';

export const originsContent = {
    sectionTitle: 'A World of Flavor, Sourced Without Compromise',
    mapAlt: 'Brilliance Solutions Global Sourcing Network',
    cards: [
        {
            icon: 'globe',
            title: 'Oceania & Europe',
            description:
                "Leveraging a premier network across Oceania and Europe, Brilliance Solutions imports exceptional meat products, sourcing precision grain-fed tenderness alongside flavorful continental selections from Australia, New Zealand, Spain, and the Netherlands.",
        },
        {
            icon: 'map-pinned',
            title: 'Americas',
            description:
                'Brazil, Argentina, and Uruguay: Premium, robust grass-fed selections. Leveraging elite partnerships, Brilliance Solutions delivers high-yielding bovine cuts defined by exceptional flavor and absolute Halal compliance.',
        },
        {
            icon: 'compass',
            title: 'Africa & Asia',
            description:
                'Kenya, South Africa, Ethiopia, Pakistan & India: Elite ovine and specialized regional proteins. Brilliance Solutions leverages trusted global partnerships to deliver versatile, high-yield meat products defined by value and absolute Halal compliance.',
        },
    ] satisfies IconCard[],
};
